.emoji-picker {
  :global(.emoji-picker-react) {
    background-color: var(--color__background);
    border: 0;
    box-shadow: none;
    color: var(--color__label);
    font-family: inherit !important;
    height: 100%;
    width: 100%
  }

  :global(.emoji-picker-react .emoji-categories button) {
    @media (prefers-color-scheme: dark) {
      -webkit-filter: invert(100%);
      filter: invert(100%);
    }
  }

  :global(.emoji-picker-react .content-wrapper-epr) {
    overflow-y: auto;
  }

  :global(.emoji-picker-react input.emoji-search) {
    background-color: var(--color__background);
    border-color: var(--color__line-light);
    color: var(--color__label);
    font: inherit;
    padding: var(--spacing__small);
  }

  :global(.emoji-picker-react .active-category-indicator-wrapper .active-category-indicator) {
    background: rgb(var(--color__primary));
  }

  :global(.emoji-picker-react .emoji-group:before) {
    background-color: var(--color__background);
    text-transform: capitalize;
  }

  :global(.emoji-picker-react .emoji-categories) {
    flex-flow: wrap;
    
    :global(.dark-mode) & {
      filter: invert(100%);
    }
  }
}

.emoji-picker__button {
  align-items: center;
  background: none;
  border: 0;
  cursor: pointer;
  color: rgb(var(--color__primary));
  display: flex;
  flex: 1 0 calc(var(--spacing)*2.5);
  height: calc(var(--spacing)*2.5);
  justify-content: center;
  padding: 0;
  transition: all .2s ease-in-out;
  width: calc(var(--spacing)*2.5);

  > svg {
    height: 100%;
    width: 100%;
  }

  &:hover, &.active {
    color: var(--color__label);
  }

  :global(.dark-mode) & {
    color: var(--color__label);

    &:hover {
      color: rgb(var(--color__primary));
    }
  }
}
